import { prefixObjectValues } from '../utils';

const contractOverview = {
  contractOverviewTab: 'contract-overview',
  listingTitle: 'listing-title',
  employerInfo: 'employer-info',
  subspecialties: 'subspecialties',
  listingStatus: 'listing-status',
  listingDescription: 'listing-description',
  totalContractValue: 'total-contract-value',
  ftesRequired: 'ftes-required',
  shiftsPerYear: 'shifts-per-year',
  hoursPerShift: 'hours-per-shift',
  totalShifts: 'total-shifts',
  startDate: 'start-date',
  endDate: 'end-date',
  contractLength: 'contract-length',
  renewable: 'renewable',
  workLocation: 'work-location',
  facilities: 'facilities',
  states: 'states',
  shiftDistribution: 'shift-distribution',
};

export default prefixObjectValues(contractOverview, 'listing-search-contract-overview');
